var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_2855)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9712 42.8491C26.7731 43.6507 28.0733 43.6505 28.875 42.8491C29.6772 42.0469 29.6772 40.747 28.8747 39.9448L20.9843 32.0546L43.8334 32.0524C44.9675 32.0521 45.8865 31.1331 45.8865 29.9985C45.8863 28.8645 44.9672 27.9457 43.8332 27.9457L20.9832 27.9479L28.8755 20.056C29.6774 19.2541 29.6774 17.9536 28.8755 17.152C28.4744 16.7512 27.949 16.5505 27.4234 16.5505C26.898 16.5505 26.3726 16.7512 25.9715 17.1517L14.5742 28.5488C14.1889 28.9338 13.9727 29.4559 13.9727 30.0007C13.9729 30.5455 14.1892 31.0673 14.5744 31.4531L25.9712 42.8491Z",
    fill: "#211F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_2855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.0b8d259a9ab7deac7e8420f0eacaf5ec.svg";
export { ForwardRef as ReactComponent };